(function (root, factory) {
  var api = factory();
  if (typeof module === 'object' && module.exports) module.exports = api;
  if (root) {
    root.FrostixCollectionInfiniteScroll = api;
    api.registerInfiniteScrollElement(root);
  }
})(typeof window !== 'undefined' ? window : null, function () {
  function productKey(node) {
    return String((node && node.dataset && node.dataset.productId) || '');
  }

  function appendUniqueProducts(currentGrid, nextGrid) {
    if (!currentGrid || !nextGrid) return 0;

    var seen = new Set(
      Array.from(currentGrid.children || [])
        .map(productKey)
        .filter(Boolean)
    );
    var appended = 0;

    Array.from(nextGrid.children || []).forEach(function (node) {
      var key = productKey(node);
      if (key && seen.has(key)) return;
      if (key) seen.add(key);
      currentGrid.appendChild(node);
      appended += 1;
    });

    return appended;
  }

  function getNextPageUrl(pageRoot) {
    var nextLoader = pageRoot && pageRoot.querySelector('collection-infinite-scroll');
    return nextLoader && nextLoader.dataset ? nextLoader.dataset.nextUrl || '' : '';
  }

  function registerInfiniteScrollElement(target) {
    if (!target || !target.customElements || !target.HTMLElement) return null;
    var existing = target.customElements.get('collection-infinite-scroll');
    if (existing) return existing;

    class CollectionInfiniteScroll extends target.HTMLElement {
      connectedCallback() {
        if (this._initialized) return;
        this._initialized = true;
        this._link = this.querySelector('[data-infinite-scroll-link]');
        this._status = this.querySelector('[data-infinite-scroll-status]');
        this._grid = target.document.getElementById('product-grid');

        if (!this._link || !this.dataset.nextUrl || !this._grid || !target.IntersectionObserver) return;

        this.classList.add('is-active');
        this._linkTabIndex = this._link.getAttribute('tabindex');
        this._link.setAttribute('tabindex', '-1');
        this._link.classList.add('visually-hidden');
        this._observer = new target.IntersectionObserver(
          (entries) => {
            if (entries.some((entry) => entry.isIntersecting)) this._load();
          },
          {rootMargin: '600px 0px'}
        );
        this._observer.observe(this);
      }

      disconnectedCallback() {
        if (this._observer) this._observer.disconnect();
        if (this._abortController) this._abortController.abort();
        this._grid = null;
      }

      _ownsGrid(grid) {
        return this.isConnected && this._grid === grid && target.document.getElementById('product-grid') === grid;
      }

      async _load() {
        if (this._loading || !this.dataset.nextUrl || !this._grid) return;
        this._loading = true;
        var pageUrl = this.dataset.nextUrl;
        var owningGrid = this._grid;
        var controller = new target.AbortController();
        this._abortController = controller;
        if (this._observer) this._observer.unobserve(this);
        if (this._status) this._status.textContent = this.dataset.loadingLabel || '';

        try {
          var response = await target.fetch(pageUrl, {
            credentials: 'same-origin',
            signal: controller.signal,
          });
          if (response.ok === false) throw new Error('Collection page request failed');
          var html = await response.text();
          if (!this._ownsGrid(owningGrid)) return;

          var page = new target.DOMParser().parseFromString(html, 'text/html');
          var nextGrid = page.getElementById
            ? page.getElementById('product-grid')
            : page.querySelector('#product-grid');
          if (!nextGrid) throw new Error('Collection grid missing from next page');
          if (!this._ownsGrid(owningGrid)) return;

          appendUniqueProducts(owningGrid, nextGrid);
          var nextUrl = getNextPageUrl(page);
          this.dataset.nextUrl = nextUrl;
          if (this._status) this._status.textContent = '';

          if (nextUrl) {
            this._link.href = nextUrl;
            if (this._observer) this._observer.observe(this);
          } else {
            this.hidden = true;
            if (this._observer) this._observer.disconnect();
          }

          if (typeof target.initProductCardActions === 'function') {
            target.initProductCardActions(target.document);
          }
          if (typeof target.initializeScrollAnimationTrigger === 'function') {
            target.initializeScrollAnimationTrigger();
          }
          if (target.CustomEvent) {
            this.dispatchEvent(
              new target.CustomEvent('collection:products-appended', {
                bubbles: true,
              })
            );
          }
        } catch (error) {
          if (controller.signal.aborted || !this._ownsGrid(owningGrid)) return;
          this.classList.remove('is-active');
          this._link.classList.remove('visually-hidden');
          if (this._linkTabIndex === null) {
            this._link.removeAttribute('tabindex');
          } else {
            this._link.setAttribute('tabindex', this._linkTabIndex);
          }
          if (this._status) this._status.textContent = '';
        } finally {
          if (this._abortController === controller) {
            this._abortController = null;
            this._loading = false;
          }
        }
      }
    }

    target.customElements.define('collection-infinite-scroll', CollectionInfiniteScroll);
    return CollectionInfiniteScroll;
  }

  return {
    appendUniqueProducts: appendUniqueProducts,
    getNextPageUrl: getNextPageUrl,
    registerInfiniteScrollElement: registerInfiniteScrollElement,
  };
});
